import { useState, useEffect, useContext, useCallback } from 'react';
import { LocaleContext } from '@profile-ui-mono/utilities/context';
import { getLocale } from '@profile-ui/shared-components';
import { subscribe, unsubscribe } from '../helpers/customEventListener';

/**
 * Invokes universalFooter's render method when the footer container is ready inside the DOM.
 */
const useUniversalFooter = () => {
  const { locale } = useContext(LocaleContext);
  const [isInject, setIsInject] = useState(false);

  const injectFooter = useCallback(() => {
    const config = {
      locale: getLocale(locale),
      environment: window.$profileEnvVars.REACT_APP_STAGE || 'dev',
      hideMegaFooter: true,
    };

    window.adsk.components.universalFooter.unmount();
    window.adsk.components.universalFooter.render('universal-footer-container', config);

    setIsInject(true);
  }, [locale]);

  useEffect(() => {
    subscribe('container_mount', injectFooter);
    // This state was added for updating locale on the current page. When locale is changing, trigger is not happening for current page. 
    // To update language in footer we are calling injectFooter one more time. But footer should exist on the page already.
    if (isInject) {
      injectFooter();
    }

    return () => {
      unsubscribe('container_mount', injectFooter);
    };
  }, [locale]);
};

export default useUniversalFooter;
